var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"8","height":"12","viewBox":"0 0 8 12"}},[_c('path',{attrs:{"fill-rule":"evenodd","fill":"currentColor","d":"M8,3.63636364 L4,0 L0,3.63636364 L8,3.63636364 Z M7.86666667,8.48484848 L4,12 L0.133333333,8.48484848 L7.86666667,8.48484848 Z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-295c73a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-double-arrows.vue
// module id = 867
// module chunks = 0